var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('newsletter-form',{attrs:{"background-color":_vm.data.backgroundColor,"slice-width":_vm.data.sliceWidth,"intro-header":_vm.data.introHeader,"header":_vm.data.header,"footer-text":_vm.data.footerText}})}
var staticRenderFns = []

export { render, staticRenderFns }